// src/v2/components/modules/Reports/SeparatedEmployeeReport/SeparatedEmployeeReportModule.js
import React, { useState, useCallback } from 'react';
import { useFilterManager } from '../../../../hooks/useFilterManager';
import { DynamicFilterBar } from '../../../filters/DynamicFilterBar';
import { LoadingSpinner } from '../../../../../common/Loading';
import { Button } from '../../../../../common/APICommon';

export const SeparatedEmployeeReportModule = ({ reportHook }) => {
  const [dateFrom, setDateFrom] = useState("");
  const [dateTo, setDateTo] = useState("");

  const {
    activeFilterState,
    onFilterChange,
    apiFilterPayload,
    resetFilters,
    loadingEnums
  } = useFilterManager(['COMPANY', 'DEPARTMENT', 'CLASSIFICATION']);

  const handleClear = useCallback(() => {
    resetFilters();
    setDateFrom("");
    setDateTo("");
  }, [resetFilters]);

  const handleGenerate = () => {
    if (!activeFilterState.COMPANY || !dateFrom || !dateTo) {
      alert("Please select Company and Date Range");
      return;
    }

    const queryParams = {
      companyId: activeFilterState.COMPANY.id,
      dateFrom,
      dateTo,
      filters: JSON.stringify(apiFilterPayload)
    };

    const companyName = activeFilterState.COMPANY.name || activeFilterState.COMPANY.fullName || "";

    // Trigger direct Fetch + Generate + Download
    reportHook.generateAndDownload(queryParams, dateFrom, dateTo, companyName);
  };

  return (
    <div className="ReportsInfo shadow-xl bg-white rounded-lg p-6 border border-gray-100">

      {/* Breadcrumb Style - PRESERVED */}
      <div className='flex items-center text-sm mb-2'>
        <span className="text-gray-400">Reports</span>
        <span className="mx-2 text-gray-400">{">"}</span>
        <span className="border-b border-gray-800 text-gray-800 font-medium tracking-tight">Separated Employee Report</span>
      </div>

      {/* H3 Section - PRESERVED */}
      <div className="mb-6">
        <h3 className="text-xl font-bold text-customMainColor uppercase tracking-tight">Separated Employee Report</h3>
      </div>

      {/* Filter Section */}
      <div className="bg-gray-50 p-5 rounded-xl border border-gray-200 mb-6">
        <div className="mb-4">
          <DynamicFilterBar
            requestedFilters={['COMPANY', 'DEPARTMENT', 'CLASSIFICATION']}
            activeFilterState={activeFilterState}
            onFilterChange={onFilterChange}
            showButtons={false}
            gridClass="grid grid-cols-1 md:grid-cols-3 gap-6 my-2"
          />
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 items-center">
          {/* Date From */}
          <div className="flex flex-col justify-center my-2">
            <label className="text-sm font-medium text-gray-700 mb-1">Separation Date From</label>
            <input
              type="date"
              className={`h-[34px] border rounded px-2 text-sm border-gray-300 outline-none focus:border-blue-500 transition-colors
                    ${dateFrom ? "text-gray-700 font-semibold" : "text-gray-400"}`}
              value={dateFrom}
              onChange={(e) => setDateFrom(e.target.value)}
            />
          </div>
          {/* Date To */}
          <div className="flex flex-col justify-center my-2">
            <label className="text-sm font-medium text-gray-700 mb-1">Separation Date To</label>
            <input
              type="date"
              className={`h-[34px] border rounded px-2 text-sm border-gray-300 outline-none focus:border-blue-500 transition-colors
                    ${dateTo ? "text-gray-700 font-semibold" : "text-gray-400"}`}
              value={dateTo}
              onChange={(e) => setDateTo(e.target.value)}
            />
          </div>
        </div>

        {/* Action Buttons */}
        <div className="flex gap-3 mt-8 border-t border-gray-200 pt-5">
          <Button
            name="GENERATE & DOWNLOAD"
            className="bg-blue-600 hover:bg-blue-700 text-white px-8 py-2.5 rounded-lg font-bold shadow-sm transition-all"
            onClick={handleGenerate}
          />
          <Button
            name="CLEAR"
            className="bg-white border border-gray-300 text-gray-600 hover:bg-gray-100 px-8 py-2.5 rounded-lg font-bold transition-all"
            onClick={handleClear}
          />
        </div>
      </div>

      <LoadingSpinner loading={reportHook.loading || loadingEnums} />
    </div>
  );
};